<template>
  <div class="product-detail" v-if="product">
    <!-- 页头 -->
    <section class="page-header text-white py-5">
      <div class="container">
        <h1 class="detail-title">{{ product.name }}</h1>
        <p class="detail-tagline">{{ product.tagline }}</p>
      </div>
    </section>

    <!-- 概览 -->
    <section class="overview py-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 mb-4 mb-lg-0">
            <div class="hero-frame">
              <img :src="product.hero" :alt="product.name" class="img-fluid">
            </div>
          </div>
          <div class="col-lg-6">
            <span class="cat-badge">{{ category.name }}</span>
            <p class="lead intro-text">{{ product.intro }}</p>
            <div class="value-list">
              <div class="value-item d-flex" v-for="(v, i) in product.values" :key="i">
                <div class="value-icon"><i :class="v.icon"></i></div>
                <div>
                  <h6 class="value-title mb-1">{{ v.title }}</h6>
                  <p class="value-desc mb-0">{{ v.desc }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品系列 / 型号（硬件类） -->
    <section class="gallery-section py-5 bg-light" v-if="product.gallery">
      <div class="container">
        <div class="section-header text-center mb-5">
          <h2 class="section-title">{{ $t('detail.gallerySeries') }}</h2>
          <p class="section-subtitle">{{ product.subtitle || $t('detail.gallerySubDefault') }}</p>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-4 col-6 mb-4" v-for="(g, i) in product.gallery" :key="i">
            <div class="gallery-card bg-white rounded shadow-sm h-100">
              <div class="gallery-img">
                <img :src="g.img" :alt="g.name">
                <span v-if="g.tag" class="gallery-tag">{{ g.tag }}</span>
              </div>
              <div class="gallery-body p-3">
                <h6 class="gallery-name mb-1">{{ g.name }}</h6>
                <p class="gallery-desc text-muted mb-0">{{ g.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { getProduct, getCategory } from '@/data/catalog'

export default {
  name: 'ProductDetail',
  computed: {
    product() {
      return getProduct(this.$route.params.slug)
    },
    category() {
      return this.product ? getCategory(this.product.category) : {}
    }
  },
  watch: {
    product(val) {
      if (!val) this.$router.replace('/products')
      else document.title = val.name + ' - ' + this.$t('nav.brand')
    }
  },
  created() {
    if (!this.product) {
      this.$router.replace('/products')
    } else {
      document.title = this.product.name + ' - ' + this.$t('nav.brand')
    }
  }
}
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #002850 0%, #0a4d8c 100%);
}
.detail-title { font-size: 2.4rem; font-weight: 700; margin-bottom: 0.5rem; }
.detail-tagline { font-size: 1.15rem; opacity: 0.9; margin-bottom: 0; }
.hero-frame {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 40, 80, 0.18);
  background: #f4f7fb;
}
.hero-frame img { width: 100%; display: block; }

.cat-badge {
  display: inline-block;
  background: #e7f1ff;
  color: #0a4d8c;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.25rem 0.85rem;
  border-radius: 999px;
  margin-bottom: 1rem;
}
.intro-text { font-size: 1.1rem; color: #333; line-height: 1.8; margin-bottom: 1.75rem; }

.value-item { margin-bottom: 1.25rem; }
.value-icon {
  flex: 0 0 48px;
  width: 48px; height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #007bff 0%, #0a4d8c 100%);
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.2rem;
  margin-right: 1rem;
}
.value-title { font-weight: 700; color: #1a1a1a; }
.value-desc { color: #6c757d; font-size: 0.95rem; }

.gallery-card { transition: transform 0.3s ease, box-shadow 0.3s ease; overflow: hidden; }
.gallery-card:hover { transform: translateY(-6px); box-shadow: 0 12px 28px rgba(0,0,0,0.12) !important; }
.gallery-img {
  position: relative;
  height: 160px;
  background: linear-gradient(135deg, #0a4d8c 0%, #06325c 100%);
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
}
.gallery-img img { width: 100%; height: 100%; object-fit: cover; }
.gallery-tag {
  position: absolute; top: 8px; right: 8px;
  background: rgba(0, 123, 255, 0.92);
  color: #fff; font-size: 0.72rem;
  padding: 2px 8px; border-radius: 999px;
}
.gallery-name { font-weight: 600; font-size: 0.95rem; }
.gallery-desc { font-size: 0.82rem; }

@media (max-width: 768px) {
  .detail-title { font-size: 1.8rem; }
}
</style>
